import { render } from "./RoomCreate.vue?vue&type=template&id=d9e56b6c&scoped=true"
import script from "./RoomCreate.vue?vue&type=script&lang=js"
export * from "./RoomCreate.vue?vue&type=script&lang=js"

import "./RoomCreate.vue?vue&type=style&index=0&id=d9e56b6c&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e56b6c"]])

export default __exports__